'use strict';
import MxRichTextBoxCtrl from './mx-rich-text-box';
import template from './mx-rich-text-box.html';

/**
 * @ngdoc directive
 * @name mx.agent:mxRichTextBox
 * @module mx.agent
 * @restrict 'E'
 * @scope {}
 * @description Rich text box (WYSIWYG editor).
 * @param {string} ng-model= - editing model as html.
 * @param {boolean} advancedMode@ - (default: `true`) there are 2 modes: "simple" and "advanced".
 *        For mobile-device it uses "simple" mode always, no metter the value.
 *        If "advancedMode" set as `true` then for wide-screens will be used "advanced" mode.
 *        If "advancedMode" set as `false` then for wide-screens will be used "simple" mode.
 * @param {boolean} allowCodeEditor@ - allow to enable toolbar which opens code editor dialog
 * @param {callback} on-focus& - fires of focus.
 * @param {callback} on-blur& - fires of blur.
 * @param {boolean} set-focus@  - if `true` then the focus will be set automatically.
 * @param {object} editor-options - sets additional editor options.
 * @param {function} external-setup - additional setup for tinyMce. Will be executed after standard Setup
 * @usage <mx-rich-text-box nd-model="myHtml"></mx-rich-text-box>
 */

angular.module('mx.SolutionBuilderAgent').directive('mxRichTextBox', function mxRichTextBoxDirective() {
	var directive = new mx.components.FormControlBase(MxRichTextBoxCtrl, null, template);

	angular.extend(directive.bindToController, {
		toolbar: '=',
		advancedMode: '@',
		allowCodeEditor: '@',
		onBlur: '&',
		onFocus: '&',
		setFocus: '@',
		_options: '=?editorOptions',
		externalSetup: '=?',
		ignoreReadonly: '=?',
		isFullscreenModeEnabled: '<?',
		onFullscreenToggle: '&',
		height: '@',
	});
	return directive;
});
